import { connect } from 'react-redux';
import { AuditLogs } from './component';
import { AppState } from 'pages/app/state';

const mapStateToProps = ({ auditLogs }: AppState) => {
  return {
    auditLogs: auditLogs.auditLogs
  };
};

export default connect(mapStateToProps)(AuditLogs);


// WEBPACK FOOTER //
// ./src/components/audit-logs/index.ts